import React, { useState, useEffect } from "react";
import axios from "axios";
import OptionView from "./OptionView.js";

const VoteComponent = ({ parse_session, hostURL }) => {
  const [optionData,setOptionData] = useState([]);
  const [disableVoteOption,setDisableVoteOption] = useState(false);

  useEffect(() => {
    axios.get(`${hostURL}/vdata`)
    .then(res => {
      if(typeof(res.data)!=="string") {
        setOptionData(res.data);
      }
    })
    .catch(err => console.log(`[Option${err.name}]: ${err.code} [Status]: ${err.request.status}`));
  }, [hostURL]);

  useEffect(() => {
    if(JSON.stringify(optionData)!=="[]" && (!(localStorage.getItem("pp-prj-vote")!==null && localStorage.getItem("pp-prj-vote-completion")==="over"))) {
      axios.get(`${hostURL}/vdata`)
      .then(res => {
        if(typeof(res.data)!=="string" && (JSON.stringify(optionData)!==JSON.stringify(res.data))) {
          // console.log("re-rendering");
          setOptionData(res.data);
        }
      })
      .catch(err => console.log(`[Option${err.name}]: ${err.code} [Status]: ${err.request.status}`));
    }
  });

  let ls_sts = (localStorage.getItem("pp-prj-vote")!==null && 
    (localStorage.getItem("pp-prj-vote-completion")==="ongoing" || localStorage.getItem("pp-prj-vote-completion")==="over"));

  return (
    <div className="vote_component">
      <h2>{parse_session.title}</h2>
      <h3>
        <span>{parse_session.sub_title}</span>
        <span>|</span>
        <span className={(parse_session.status!=="ongoing") ? "indicator" : "indicator recorded"}>
          {(!(parse_session.vote==="over" || ls_sts)) ? "vote pending..." : 
            ((parse_session.vote==="over") ? "Voting is over!" : "Thankyou, your vote has been recorded!")}
        </span>
      </h3>
      {optionData.map((elm,index) => {

        return <OptionView
          key={index}
          db_elm_id={elm.id}
          elm={index+1} 
          title={elm.title}
          ratio={elm.count}
          session_id={parse_session.id}
          session_sts={parse_session.vote}
          login_count={parse_session.logins}
          baseURL={hostURL}
          vote_status={[disableVoteOption,(val) => setDisableVoteOption(val)]}
        />
      })}
    </div>
  );
}

export default VoteComponent;